export default __webpack_public_path__ + "811983a93d6817529003ffa15205e4d2.ttf";